import {useEffect, useState} from 'react';
import {generateCreativeQuery} from '../lib/adjust';

/**
 * Adjust の creative query を取得する
 *
 * creative query はクライアントサイドレンダリングで location.search を参照する必要があるため、
 * 初回レンダリング時に useEffect で location.search を state に保存して利用する。
 * レンダリング後に動的に query string が更新されることはない。
 * 仮に更新されたとしても、広告流入元を記録するための値なので generateCreativeQuery に連携する必要はない。
 *
 * @param {Object} params - params
 * @param {string} params.pathname - location の pathname
 * @returns {string} - creativeのurlクエリ(adjust用)
 */
export const useAdjustCreativeQuery = ({pathname}: {pathname: string}) => {
  // query string が存在しない場合、location.search は undefined になる
  const [search, setSearch] = useState<string | undefined>(undefined);
  useEffect(() => {
    if (search !== location.search) {
      setSearch(location.search);
    }
  }, [search]);
  return generateCreativeQuery({
    pathname,
    search: search || '',
  });
};
